(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('HolidayDialogController', HolidayDialogController);

    HolidayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Holiday', 'Province', 'Country', 'DateUtils'];

    function HolidayDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Holiday, Province, Country, DateUtils) {
        var vm = this;

        vm.holiday = entity;

        vm.provinces = Province.query();
        vm.countries = Country.query();

        vm.provinceIds = [];
        angular.forEach(vm.holiday.provinces, function(prov) {
            vm.provinceIds.push(prov.id);
        });
        vm.provincesUpdated = provincesUpdated;

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            var holidayToSave = angular.copy(vm.holiday);
            holidayToSave.startDate = DateUtils.convertLocalDateToServer(vm.holiday.startDate);
            holidayToSave.endDate = DateUtils.convertLocalDateToServer(vm.holiday.endDate);

            if (vm.holiday.id !== null) {
                Holiday.update(holidayToSave, onSaveSuccess, onSaveError);
            } else {
                Holiday.save(holidayToSave, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function provincesUpdated() {
            vm.holiday.provinces = [];
            angular.forEach(vm.provinceIds, function(provinceId) {
                var tempProvince = vm.provinces.find(function(prov) { return prov.id == provinceId; });
                vm.holiday.provinces.push(tempProvince);
            });
        }

    }
})();
